import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AlertController } from '@ionic/angular';

export const authGuard: CanActivateFn = async (route, state) => {
  const router = inject(Router);
  const alertCtrl = inject(AlertController);

  const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';

  if (!isLoggedIn) {
    router.navigate(['/login']);
    return false;
  }

  try {
    const profile = JSON.parse(localStorage.getItem('UserProfileData') || '{}');
    const role = profile.result?.role;

    // Dashboard routes require an active property to be selected
    // Exception: add-property page is accessible from property-select without a property yet
    if (state.url.startsWith('/dashboard') && !state.url.includes('/add-property')) {
      const activePropertyId = localStorage.getItem('activePropertyId');
      if (!activePropertyId) {
        return router.navigate(['/property-select']).then(() => false);
      }

      // Redirect complaint roles away from the plain /dashboard root
      if (['csc', 'dm', 'hm', 'management'].includes(role)) {
        if (state.url === '/dashboard' || state.url === '/dashboard/') {
          return router.navigate(['/dashboard/complaint-list']).then(() => false);
        }
      }
    }

    return true;
  } catch {
    return showLoginPopup(alertCtrl, router, state.url);
  }
};

async function showLoginPopup(
  alertCtrl: AlertController,
  router: Router,
  returnUrl: string,
  message = 'You must be logged in to continue.'
): Promise<boolean> {
  const alert = await alertCtrl.create({
    header: 'Login Required',
    message,
    buttons: [
      { text: 'Cancel', role: 'cancel' },
      {
        text: 'Login',
        handler: () => {
          router.navigate(['/login']);
        }
      }
    ]
  });
  await alert.present();
  return false;
}
